import { createSlice } from '@reduxjs/toolkit'
import { API } from 'src/utils/interceptor'
import Sentry from 'src/utils/sentry'
import { getUploadedInvoices } from './NewInvoicesSlice'

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState: {
    items: [],
  },
  reducers: {
    setInvoice: (state, action) => {
      state.items = action.payload
    },
  },
})

export const { setInvoice } = invoiceSlice.actions

export const fetchInvoice = (venueId, date) => async dispatch => {
  try {
    const data = await API.get(
      'api',
      `invoice/${venueId}${date ? `/${date}` : ''}`,
    )
    dispatch(setInvoice(data))
  } catch (e) {
    console.error(e)
    Sentry.captureException(e)
    return false
  }
}

export const getInvoiceByUrl = invoiceUrl => async () => {
  try {
    const data = await API.get('api2', `invoices/getInvoicebyUrl`, {
      queryStringParameters: { invoiceUrl },
    })
    if (!data) {
      throw new Error('Invoice not found')
    }
    return data?.data || null
  } catch (e) {
    console.error(e)
    Sentry.captureException(e)
    return false
  }
}

export const updateInvoiceStatus =
  (invoiceId, venueId, status) => async dispatch => {
    try {
      const data = await API.put('api2', `invoices/error`, {
        body: {
          invoiceId,
          venueId,
          status,
        },
      })
      if (data) {
        dispatch(getUploadedInvoices(venueId))
      }
      return data || null
    } catch (e) {
      console.error(e)
      Sentry.captureException(e)
      return false
    }
  }

export default invoiceSlice
